document.addEventListener("DOMContentLoaded", () => {
  document.documentElement.classList.add("rudra-ready");

  const pageLoader = document.querySelector("[data-page-loader]");
  const ignoredNavigationSelectors = [
    "[data-rudra-menu-button]",
    "[data-rudra-menu-close]",
    "[data-rudra-search-open]",
    "[data-rudra-search-close]",
    "[data-rudra-cart-open]",
    "[data-rudra-cart-close]",
    "[data-cart-qty-minus]",
    "[data-cart-qty-plus]",
    "[data-cart-remove]",
    "[data-wishlist]",
    "[data-quick-view]",
    "[data-quick-view-close]",
    "[data-add-to-cart]",
    "[data-product-thumb]",
    "[data-qty-minus]",
    "[data-qty-plus]",
    "[data-filter-open]",
    "[data-filter-close]"
  ];

  const showPageLoader = () => {
    if (!pageLoader) return;
    document.body.classList.add("rudra-page-loading");
    pageLoader.setAttribute("aria-hidden", "false");
  };

  const hidePageLoader = () => {
    if (!pageLoader) return;
    document.body.classList.remove("rudra-page-loading");
    pageLoader.setAttribute("aria-hidden", "true");
  };

  const isIgnoredClick = (event) => (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    ignoredNavigationSelectors.some((selector) => event.target.closest(selector))
  );

  const shouldLoadForLink = (link) => {
    if (!link) return false;
    const href = link.getAttribute("href");

    if (!href || href === "#" || href.startsWith("#")) return false;
    if (link.target === "_blank" || link.hasAttribute("download")) return false;
    if (href.startsWith("mailto:") || href.startsWith("tel:") || href.startsWith("javascript:")) return false;

    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin) return false;

    const samePath = destination.pathname === window.location.pathname;
    const sameSearch = destination.search === window.location.search;
    if (samePath && sameSearch && destination.hash) return false;

    return true;
  };

  const shouldLoadForForm = (form) => {
    if (!form || form.target === "_blank") return false;
    if (form.matches("[data-product-form]")) return false;

    const action = new URL(form.action || window.location.href, window.location.href);
    const cartAddUrl = document.body.dataset.cartAddUrl;
    const cartChangeUrl = document.body.dataset.cartChangeUrl;

    if (cartAddUrl && action.pathname === cartAddUrl) return false;
    if (cartChangeUrl && action.pathname === cartChangeUrl) return false;
    if (action.pathname.includes("/cart/add") || action.pathname.includes("/cart/change")) return false;

    return action.origin === window.location.origin;
  };

  document.addEventListener("click", (event) => {
    if (isIgnoredClick(event)) return;

    const link = event.target.closest("a[href]");
    if (shouldLoadForLink(link)) {
      showPageLoader();
    }
  });

  document.addEventListener("submit", (event) => {
    if (event.defaultPrevented) return;

    if (shouldLoadForForm(event.target)) {
      showPageLoader();
    }
  });

  window.addEventListener("pageshow", hidePageLoader);

  const filterDrawer = document.querySelector("[data-filter-drawer]");
  const filterOpen = document.querySelector("[data-filter-open]");
  const filterClose = document.querySelector("[data-filter-close]");

  const closeFilters = () => {
    if (!filterDrawer || !filterOpen) return;
    filterDrawer.classList.remove("is-open");
    filterDrawer.setAttribute("aria-hidden", "true");
    filterOpen.setAttribute("aria-expanded", "false");
    document.body.classList.remove("rudra-filter-open");
  };

  if (filterDrawer && filterOpen) {
    filterOpen.addEventListener("click", () => {
      filterDrawer.classList.add("is-open");
      filterDrawer.setAttribute("aria-hidden", "false");
      filterOpen.setAttribute("aria-expanded", "true");
      document.body.classList.add("rudra-filter-open");
    });
  }

  if (filterClose) {
    filterClose.addEventListener("click", closeFilters);
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeFilters();
    }
  });
});
